<template>
  <div class="inspectTimeoutData">
    <div class="col-12 row text-center m-0 table-responsive px-0" style="">
      <template v-if="inspectTimeoutShowDetail == false">
        <div>
          <div
            class="text-right"
            style="max-width: 620px;color: rgb(95, 95, 95)"
          >
            ※超時定義:前後檢驗間隔時間大於(含)2時16分00秒
          </div>
          <b-table
            :items="inspectTimeoutDataItem"
            :fields="inspectTimeoutDataFields"
            style="max-width: 620px;"
            sticky-header="610px"
            :no-border-collapse="true"
            class="inspectTimeoutData-table-detail sticky table-row-click"
            @row-clicked="onRowClicked"
          >
            <!-- lazy -->
            <template #thead-top="">
              <!-- 第一行表頭 -->
              <b-tr>
                <b-th
                  style="
                background-color: #4b8c80!important;
                color: #ffffff!important;
              "
                >
                  <div>機台總數</div>
                </b-th>
                <b-th>
                  <div>總生產批數</div>
                </b-th>
                <b-th>
                  <div>總檢驗筆數</div>
                </b-th>
                <b-th>
                  <div>總超時筆數</div>
                </b-th>
              </b-tr>
              <!-- 第二行表頭 -->
              <b-tr @click="showDetail">
                <b-th>
                  <div>{{ device_total_qty.toLocaleString("en-US") }}</div>
                </b-th>
                <b-th>
                  <div>{{ batch_total_qty.toLocaleString("en-US") }}</div>
                </b-th>
                <b-th>
                  <div>{{ inspect_total_qty.toLocaleString("en-US") }}</div>
                </b-th>
                <b-th>
                  <div>{{ timeout_total_qty.toLocaleString("en-US") }}</div>
                </b-th>
              </b-tr>
              <!-- 第三行表頭 -->
              <b-tr>
                <b-th
                  colspan="4"
                  style="
                background-color: #4b8c80!important;
                color: #ffffff!important;
                border-color: #4b8c80;
                font-family: 'dfyuanstd-w7';
                font-size: 1.125rem;
              "
                >
                  <span>超時分析</span>
                </b-th>
              </b-tr>
            </template>
            <template #cell(batch_qty)="data">
              {{ data.value.toLocaleString("en-US") }}
            </template>
            <template #cell(inspect_qty)="data">
              {{ data.value.toLocaleString("en-US") }}
            </template>
            <template #cell(timeout_qty)="data">
              {{ data.value.toLocaleString("en-US") }}
            </template>
          </b-table>
        </div>
      </template>
      <template v-else>
        <div class="inspectTimeoutData-back-button">
          <p @click="set_inspectTimeoutShowDetail(false)">返回</p>
        </div>
        <!-- timeout analysis -->
        <inspectTimeoutDetailData />
      </template>
    </div>
  </div>
</template>

<script>
import inspectTimeoutDetailData from "@/components/inspectTimeoutDetailData.vue";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "inspectTimeoutData",
  data() {
    return {};
  },
  watch: {
    // inspectTimeoutShowDetail: {
    //   handler() {
    //     let vm = this;
    //     if (vm.inspectTimeoutShowDetail == false) {
    //       vm.clear_inspectTimeoutDetailDataItem();
    //     }
    //   }
    // }
  },
  computed: {
    ...mapGetters({
      axiosResult: "commonaxios/get_axiosResult",
      selectPage: "getlogin/get_selectPage",
      inspectTimeoutDataFields:
        "inspectTimeoutData/get_inspectTimeoutDataFields",
      inspectTimeoutDataItem: "inspectTimeoutData/get_inspectTimeoutDataItem",
      device_total_qty: "inspectTimeoutData/get_device_total_qty",
      batch_total_qty: "inspectTimeoutData/get_batch_total_qty",
      inspect_total_qty: "inspectTimeoutData/get_inspect_total_qty",
      timeout_total_qty: "inspectTimeoutData/get_timeout_total_qty",
      inspectTimeoutShowDetail:
        "inspectTimeoutData/get_inspectTimeoutShowDetail",
      inspectTimeoutDetailData:
        "inspectTimeoutData/get_inspectTimeoutDetailData"
    })
  },
  components: {
    inspectTimeoutDetailData
  },
  methods: {
    ...mapActions({
      axiosAction: "commonaxios/axiosAction",
      set_alertMsg: "alertmodal/set_alertMsg",
      set_inspectTimeoutShowDetail:
        "inspectTimeoutData/set_inspectTimeoutShowDetail",
      set_inspectTimeoutDetailDataItem:
        "inspectTimeoutDetailData/set_inspectTimeoutDetailDataItem",
      clear_inspectTimeoutDetailDataItem:
        "inspectTimeoutDetailData/clear_inspectTimeoutDetailDataItem"
    }),
    onRowClicked(items, index, event) {
      let vm = this;
      let obj = {
        items: items,
        index: index,
        event: event
      };
      let inspectTimeoutDetailData = [];
      let device_name = obj.items.device_name;
      if (vm.inspectTimeoutDetailData[device_name] != undefined) {
        inspectTimeoutDetailData = vm.inspectTimeoutDetailData[device_name];
      }
      vm.set_inspectTimeoutShowDetail(true);
      vm.set_inspectTimeoutDetailDataItem(inspectTimeoutDetailData);
    },
    showDetail() {
      let vm = this;
      let inspectTimeoutDetailData = [];
      vm.inspectTimeoutDataItem.forEach(data => {
        if (vm.inspectTimeoutDetailData[data.device_name] != undefined) {
          inspectTimeoutDetailData = inspectTimeoutDetailData.concat(
            vm.inspectTimeoutDetailData[data.device_name]
          );
        }
      });
      vm.set_inspectTimeoutShowDetail(true);
      vm.set_inspectTimeoutDetailDataItem(inspectTimeoutDetailData);
    }
  }
};
</script>

<style></style>
<style lang="scss">
.inspectTimeoutData-table-detail.sticky {
  margin-bottom: 0;
}
.inspectTimeoutData-table-detail.sticky > thead,
.inspectTimeoutData-table-detail.sticky > thead > tr > th {
  position: sticky;
  top: 0;
}
.inspectTimeoutData-table-detail > table > thead > tr > th {
  z-index: 1 !important;
}
.inspectTimeoutData-table-detail th,
.inspectTimeoutData-table-detail td {
  height: 2.5rem;
  min-width: 115px;
  width: 155px;
  padding: 0.45rem;
  border-color: #999999 !important;
  border-bottom: 1px solid #999999 !important;
  border-right: 1px solid;
  font-weight: normal;
  font-size: 1rem;
  font-family: "dfyuanstd-w5";
  vertical-align: middle !important;
}
.inspectTimeoutData-table-detail td {
  font-size: 1rem;
}
.inspectTimeoutData-table-detail.table-row-click td,
.inspectTimeoutData-table-detail.table-row-click thead tr:nth-child(2) th {
  cursor: pointer;
}
.inspectTimeoutData-table-detail th:first-child,
.inspectTimeoutData-table-detail td:first-child {
  border-left: 1px solid;
}
.inspectTimeoutData-table-detail thead {
  position: sticky;
  top: 0;
}
.inspectTimeoutData-table-detail thead th {
  color: #000000 !important;
  background-color: #cccccc !important;
}
.inspectTimeoutData-table-detail thead tr:nth-child(1) > th {
  background-color: #4b8c80 !important;
  color: #ffffff !important;
}
.inspectTimeoutData-table-detail thead tr:nth-child(2) > th {
  background-color: #ffffff !important;
}
.inspectTimeoutData-back-button p {
  border-radius: 5px;
  background-color: #4b8c80;
  color: #ffffff;
  padding: 0px 13px;
  width: 4.25rem;
  height: 2rem;
  line-height: 2rem;
  font-size: 1.125rem;
  font-family: dfyuanstd-w7, dfyuanstd-w5;
  text-align: center;
  margin: 0px 0px 1.5rem;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/inspectTimeoutData.vue